import React, { useState } from 'react';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import AddressModal from './AddressModal';
import { useDispatch } from 'react-redux';
import { deleteAddress } from '@kfc-global/react-shared/redux/Actions/OrderservAction';
import { resetStores } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ADDRESS_STORE_CONSTANTS from './constant';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';

const DeliveryAddressView = props => {
  const dispatch = useDispatch();
  const { savedAddresses, storeSearch, tenantId, allStores, driveTime } = props;
  const [openModal, toggleModal] = useState(false);
  const [modalType, setModalType] = useState(false);
  const [address, setAddress] = useState({});
  const { MYDELIVERYADDRESSES } = ADDRESS_STORE_CONSTANTS;

  const setModal = (type, addressDetails = {}) => {
    const mode = type === 'edit' ? true : false;
    setAddress(addressDetails);
    toggleModal(true);
    setModalType(mode);
  };

  const closeModal = () => {
    document.querySelector('body').style.overflow = '';
    toggleModal(false);
    dispatch(resetStores());
  };

  const deleteAddr = addressId => {
    const { phoneNumber, customerId } = AuthManager.getInstance();
    dispatch(
      deleteAddress({
        customerId,
        phoneNumber,
        tenantId,
        addressId,
      }),
    );
  };

  const sortAddress = savedAddress => {
    return savedAddress.sort((a, b) => {
      return b.isPrimary - a.isPrimary;
    });
  };

  const addressCard = sortAddress(savedAddresses).map(item => {
    return (
      <React.Fragment>
        <div className='delivery-card bgv-set d-flex'>
          <div className='address-description d-flex'>
            <p className='address-mode'>
              <span className='text-transform-capitalize'>{item?.name}</span> {item?.isPrimary ? `(Default)` : ''}
            </p>
            <div className='delivery-details'>
              <div>
                {item?.addressLines[1] && <span>{item?.addressLines[1]}, </span>}
                {item?.addressLines[0] && <span>{item?.addressLines[0]}, </span>}
                {item?.city && <span>{item?.city}, </span>}
                {item?.state && <span>{item?.state}, </span>}
                {item?.pinCode && <span>{item?.pinCode}, </span>}
                {item?.country && <span>{item?.country}</span>}
              </div>
            </div>
          </div>
          <div className='action-btn d-flex'>
            <div onClick={() => setModal('edit', item)} data-testid='edit-testid' className='anchor-info edit-adjust'>
              Edit
            </div>
            <div onClick={() => deleteAddr(item?.id)} data-testid='delete-testid' className='anchor-info del-adjust'>
              Delete
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  });

  return (
    <div className='delivery-address-section'>
      <div className='header-text'>
        {translateWithI18Next(MYDELIVERYADDRESSES)} {savedAddresses?.length > 0 && `(${savedAddresses.length})`}
      </div>
      {savedAddresses?.length > 0 && addressCard}
      <div className='add-address'>
        <ContainedButton
          data-testid='add-testid'
          onClickHandler={() => setModal('add')}
          variant={ButtonType.tertiary}
          className={`mt-10`}
        >
          Add New Address
        </ContainedButton>
      </div>
      {openModal && (
        <AddressModal
          data-testid='address-modal'
          isOpen={openModal}
          modalType={modalType}
          storeSearch={storeSearch}
          address={address}
          tenantId={tenantId}
          driveTime={driveTime}
          allStores={allStores}
          handleClose={() => closeModal()}
        />
      )}
    </div>
  );
};
export default DeliveryAddressView;
